import * as React from "react";
import { Container } from '../components';
import { Link } from "gatsby";
import { useForm } from 'react-hook-form';
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

function Newsletter() {
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            userLocation: '',
            birthCountry: '',
        },
    });
    const data = useStaticQuery(graphql`
    query {
      phoneMockup: file(relativePath: { eq: "iphone-14-mockup.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED)
        }
      }
    }
  `)
  const image = getImage(data.phoneMockup)

    const onSubmit = async (data) => {
        data["form-name"] = "newsletterSubscription";
        const formData = Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');

        const response = await fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData
        });

        if (response.ok) {
            window.location.href = "/thank-you/";
        } else {
            console.error("Form submission failed");
        }
    };

    const commonClasses = {
        input: "h-10 mt-1 block w-full px-3 border bg-white text-holborn-blue shadow-sm focus:outline-none text-sm",
    };

    return (
        <Container className="newsletter bg-holborn-light-blue text-holborn-white">
            <div className="grid grid-cols-1 lg:grid-cols-10 gap-10 flex items-center">
                <div className="col-span-full lg:col-start-2 lg:col-end-4 hidden lg:block">
                <GatsbyImage image={image} alt="Newsletter" />
                </div>
                <div className="col-span-full grid-cols-1 lg:col-start-5 lg:col-end-10 newsletter-form py-12">
                    <h4 className="text-center text-holborn-blue pb-2">Get industry insights from the finance world, delivered to you monthly</h4>
                    <form name="newsletterSubscription" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleSubmit(onSubmit)}>
                        <div className="grid grid-cols-1 md:grid-cols-2 py-6 gap-6">
                            <div>
                                <input
                                    {...register("firstName", { required: "This field is required" })}
                                    className={`${commonClasses.input} ${errors.firstName ? 'border-holborn-red' : ''}`}
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name" />
                            </div>
                            <div>
                                <input
                                    {...register("lastName", { required: "This field is required" })}
                                    className={`${commonClasses.input} ${errors.lastName ? 'border-holborn-red' : ''}`}
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name" />
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <input
                                    {...register("email", {
                                        required: "This field is required",
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Invalid email address"
                                        }
                                    })}
                                    className={`${commonClasses.input} ${errors.email ? 'border-holborn-red' : ''}`}
                                    type="email"
                                    name="email"
                                    placeholder="Email Address" />
                            </div>
                            <div className="justify-center flex">
                                <div className="button-wrapper items-center justify-center inline-block w-full">
                                    <p className="hidden">
                                        <label>
                                            Don't fill this out if you're human: <input name="bot-field" />
                                        </label>
                                    </p>
                                    <input type="hidden" name="_redirect" value="/thank-you/" />
                                    <div className="col-span-12 text-center">
                                        <button className="mt-1 py-2 px-8 rounded-3xl transition duration-500 text-holborn-white bg-holborn-green hover:bg-holborn-blue w-full" type="submit">Subscribe</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <p className="text-center text-holborn-blue text-sm pt-5">By submitting this form, you agree to our <Link className="font-bold hover:underline" to="/privacy-notice/">Privacy Policy</Link></p>
                </div>
            </div>
        </Container>
    );
}

export default Newsletter;